import {PALETTES} from '../../../shared';

import collectionColoredBigDark from 'assets/icons/collections/collection-colored-big-dark.svg';
import collectionColoredBig from 'assets/icons/collections/collection-colored-big.svg';
import collectionColoredDark from 'assets/icons/collections/collection-colored-dark.svg';
import collectionColored from 'assets/icons/collections/collection-colored.svg';
import paletteDatalensClassic20Icon from 'assets/icons/palettes/datalens-classic20.svg';
import paletteDatalensDefault20Icon from 'assets/icons/palettes/datalens-default20.svg';
import paletteDatalensNeo20Icon from 'assets/icons/palettes/datalens-neo20.svg';
import paletteEmerald20Icon from 'assets/icons/palettes/emerald-20.svg';
import paletteGolden20Icon from 'assets/icons/palettes/golden-20.svg';
import paletteNeutral20Icon from 'assets/icons/palettes/neutral-20.svg';
import paletteOceanic20Icon from 'assets/icons/palettes/oceanic-20.svg';
import paletteTrafficLight9Icon from 'assets/icons/palettes/traffic-light-9.svg';
import visArea100p from 'assets/icons/vis-area-100p.svg';
import visArea from 'assets/icons/vis-area.svg';
import visBar100p from 'assets/icons/vis-bar-100p.svg';
import visBar from 'assets/icons/vis-bar.svg';
import visColumn100p from 'assets/icons/vis-column-100p.svg';
import visColumn from 'assets/icons/vis-column.svg';
import visCombined from 'assets/icons/vis-combined.svg';
import visDonut from 'assets/icons/vis-donut.svg';
import visFlatTable from 'assets/icons/vis-flat-table.svg';
import visGeolayers from 'assets/icons/vis-geolayers.svg';
import visHeatmap from 'assets/icons/vis-heatmap.svg';
import visLines from 'assets/icons/vis-lines.svg';
import visMetric from 'assets/icons/vis-metric.svg';
import visPie from 'assets/icons/vis-pie.svg';
import visPivot from 'assets/icons/vis-pivot.svg';
import visScatter from 'assets/icons/vis-scatter.svg';
import visTreemap from 'assets/icons/vis-treemap.svg';

export default {
    visCombined,
    visDonut,
    visFlatTable,
    visGeolayers,
    visArea100p,
    visArea,
    visBar100p,
    visBar,
    visColumn100p,
    visColumn,
    visLines,
    visScatter,
    visMetric,
    visPie,
    visPivot,
    visTreemap,
    visHeatmap,
    collectionColored,
    collectionColoredDark,
    collectionColoredBig,
    collectionColoredBigDark,
    [PALETTES.default20.id]: paletteDatalensDefault20Icon,
    [PALETTES.classic.id]: paletteDatalensClassic20Icon,
    [PALETTES.emerald.id]: paletteEmerald20Icon,
    [PALETTES.golden.id]: paletteGolden20Icon,
    [PALETTES.neutral.id]: paletteNeutral20Icon,
    [PALETTES.oceanic.id]: paletteOceanic20Icon,
    [PALETTES.trafficLight.id]: paletteTrafficLight9Icon,
    [PALETTES.datalens.id]: paletteDatalensNeo20Icon,
};
